// source: bpong.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var user_pb = require('./user_pb.js');
goog.object.extend(proto, user_pb);
goog.exportSymbol('proto.saufdings.AdvanceTournamentRequest', null, global);
goog.exportSymbol('proto.saufdings.BracketType', null, global);
goog.exportSymbol('proto.saufdings.CreateTournamentRequest', null, global);
goog.exportSymbol('proto.saufdings.DeleteTournamentRequest', null, global);
goog.exportSymbol('proto.saufdings.EliminateTeamRequest', null, global);
goog.exportSymbol('proto.saufdings.GetTournamentRequest', null, global);
goog.exportSymbol('proto.saufdings.ListTournamentsRequest', null, global);
goog.exportSymbol('proto.saufdings.Match', null, global);
goog.exportSymbol('proto.saufdings.ParticipantInput', null, global);
goog.exportSymbol('proto.saufdings.ReinstateTeamRequest', null, global);
goog.exportSymbol('proto.saufdings.RuleProt', null, global);
goog.exportSymbol('proto.saufdings.Rules', null, global);
goog.exportSymbol('proto.saufdings.Team', null, global);
goog.exportSymbol('proto.saufdings.TeamInput', null, global);
goog.exportSymbol('proto.saufdings.TeamMember', null, global);
goog.exportSymbol('proto.saufdings.Tournament', null, global);
goog.exportSymbol('proto.saufdings.TournamentList', null, global);
goog.exportSymbol('proto.saufdings.TournamentStatus', null, global);
goog.exportSymbol('proto.saufdings.TournamentStyle', null, global);
goog.exportSymbol('proto.saufdings.TournamentVisibility', null, global);
goog.exportSymbol('proto.saufdings.UpdateMatchRequest', null, global);
goog.exportSymbol('proto.saufdings.UpdateTournamentRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.Rules = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saufdings.Rules.repeatedFields_, null);
};
goog.inherits(proto.saufdings.Rules, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.Rules.displayName = 'proto.saufdings.Rules';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.RuleProt = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.RuleProt, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.RuleProt.displayName = 'proto.saufdings.RuleProt';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.CreateTournamentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saufdings.CreateTournamentRequest.repeatedFields_, null);
};
goog.inherits(proto.saufdings.CreateTournamentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.CreateTournamentRequest.displayName = 'proto.saufdings.CreateTournamentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.TeamInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saufdings.TeamInput.repeatedFields_, null);
};
goog.inherits(proto.saufdings.TeamInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.TeamInput.displayName = 'proto.saufdings.TeamInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.ParticipantInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.ParticipantInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.ParticipantInput.displayName = 'proto.saufdings.ParticipantInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.GetTournamentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.GetTournamentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.GetTournamentRequest.displayName = 'proto.saufdings.GetTournamentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.ListTournamentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.ListTournamentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.ListTournamentsRequest.displayName = 'proto.saufdings.ListTournamentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.TournamentList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saufdings.TournamentList.repeatedFields_, null);
};
goog.inherits(proto.saufdings.TournamentList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.TournamentList.displayName = 'proto.saufdings.TournamentList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.Tournament = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saufdings.Tournament.repeatedFields_, null);
};
goog.inherits(proto.saufdings.Tournament, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.Tournament.displayName = 'proto.saufdings.Tournament';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.Team = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saufdings.Team.repeatedFields_, null);
};
goog.inherits(proto.saufdings.Team, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.Team.displayName = 'proto.saufdings.Team';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.TeamMember = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.TeamMember, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.TeamMember.displayName = 'proto.saufdings.TeamMember';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.Match = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.Match, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.Match.displayName = 'proto.saufdings.Match';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.UpdateMatchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.UpdateMatchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.UpdateMatchRequest.displayName = 'proto.saufdings.UpdateMatchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.UpdateTournamentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.UpdateTournamentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.UpdateTournamentRequest.displayName = 'proto.saufdings.UpdateTournamentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.EliminateTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.EliminateTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.EliminateTeamRequest.displayName = 'proto.saufdings.EliminateTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.ReinstateTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.ReinstateTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.ReinstateTeamRequest.displayName = 'proto.saufdings.ReinstateTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.AdvanceTournamentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.AdvanceTournamentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.AdvanceTournamentRequest.displayName = 'proto.saufdings.AdvanceTournamentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saufdings.DeleteTournamentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saufdings.DeleteTournamentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saufdings.DeleteTournamentRequest.displayName = 'proto.saufdings.DeleteTournamentRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saufdings.Rules.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.Rules.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.Rules.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.Rules} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Rules.toObject = function(includeInstance, msg) {
  var f, obj = {
rulesList: jspb.Message.toObjectList(msg.getRulesList(),
    proto.saufdings.RuleProt.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.Rules}
 */
proto.saufdings.Rules.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.Rules;
  return proto.saufdings.Rules.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.Rules} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.Rules}
 */
proto.saufdings.Rules.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saufdings.RuleProt;
      reader.readMessage(value,proto.saufdings.RuleProt.deserializeBinaryFromReader);
      msg.addRules(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.Rules.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.Rules.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.Rules} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Rules.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saufdings.RuleProt.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RuleProt rules = 1;
 * @return {!Array<!proto.saufdings.RuleProt>}
 */
proto.saufdings.Rules.prototype.getRulesList = function() {
  return /** @type{!Array<!proto.saufdings.RuleProt>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saufdings.RuleProt, 1));
};


/**
 * @param {!Array<!proto.saufdings.RuleProt>} value
 * @return {!proto.saufdings.Rules} returns this
*/
proto.saufdings.Rules.prototype.setRulesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saufdings.RuleProt=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saufdings.RuleProt}
 */
proto.saufdings.Rules.prototype.addRules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saufdings.RuleProt, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saufdings.Rules} returns this
 */
proto.saufdings.Rules.prototype.clearRulesList = function() {
  return this.setRulesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.RuleProt.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.RuleProt.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.RuleProt} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.RuleProt.toObject = function(includeInstance, msg) {
  var f, obj = {
place: jspb.Message.getFieldWithDefault(msg, 1, ""),
rulename: jspb.Message.getFieldWithDefault(msg, 2, ""),
rule: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.RuleProt}
 */
proto.saufdings.RuleProt.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.RuleProt;
  return proto.saufdings.RuleProt.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.RuleProt} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.RuleProt}
 */
proto.saufdings.RuleProt.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlace(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRulename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRule(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.RuleProt.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.RuleProt.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.RuleProt} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.RuleProt.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlace();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRulename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRule();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string Place = 1;
 * @return {string}
 */
proto.saufdings.RuleProt.prototype.getPlace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.RuleProt} returns this
 */
proto.saufdings.RuleProt.prototype.setPlace = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string RuleName = 2;
 * @return {string}
 */
proto.saufdings.RuleProt.prototype.getRulename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.RuleProt} returns this
 */
proto.saufdings.RuleProt.prototype.setRulename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Rule = 3;
 * @return {string}
 */
proto.saufdings.RuleProt.prototype.getRule = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.RuleProt} returns this
 */
proto.saufdings.RuleProt.prototype.setRule = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saufdings.CreateTournamentRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.CreateTournamentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.CreateTournamentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.CreateTournamentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.CreateTournamentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
tournamentName: jspb.Message.getFieldWithDefault(msg, 1, ""),
eventId: jspb.Message.getFieldWithDefault(msg, 2, 0),
createdBy: jspb.Message.getFieldWithDefault(msg, 3, 0),
teamsList: jspb.Message.toObjectList(msg.getTeamsList(),
    proto.saufdings.TeamInput.toObject, includeInstance),
tournamentStyle: jspb.Message.getFieldWithDefault(msg, 5, 0),
visibility: jspb.Message.getFieldWithDefault(msg, 6, 0),
accessPassword: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.CreateTournamentRequest}
 */
proto.saufdings.CreateTournamentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.CreateTournamentRequest;
  return proto.saufdings.CreateTournamentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.CreateTournamentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.CreateTournamentRequest}
 */
proto.saufdings.CreateTournamentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTournamentName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEventId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCreatedBy(value);
      break;
    case 4:
      var value = new proto.saufdings.TeamInput;
      reader.readMessage(value,proto.saufdings.TeamInput.deserializeBinaryFromReader);
      msg.addTeams(value);
      break;
    case 5:
      var value = /** @type {!proto.saufdings.TournamentStyle} */ (reader.readEnum());
      msg.setTournamentStyle(value);
      break;
    case 6:
      var value = /** @type {!proto.saufdings.TournamentVisibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessPassword(value);
      break;
    case 8:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.CreateTournamentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.CreateTournamentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.CreateTournamentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.CreateTournamentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTournamentName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEventId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCreatedBy();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTeamsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.saufdings.TeamInput.serializeBinaryToWriter
    );
  }
  f = message.getTournamentStyle();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
};


/**
 * optional string tournament_name = 1;
 * @return {string}
 */
proto.saufdings.CreateTournamentRequest.prototype.getTournamentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.CreateTournamentRequest} returns this
 */
proto.saufdings.CreateTournamentRequest.prototype.setTournamentName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 event_id = 2;
 * @return {number}
 */
proto.saufdings.CreateTournamentRequest.prototype.getEventId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.CreateTournamentRequest} returns this
 */
proto.saufdings.CreateTournamentRequest.prototype.setEventId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 created_by = 3;
 * @return {number}
 */
proto.saufdings.CreateTournamentRequest.prototype.getCreatedBy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.CreateTournamentRequest} returns this
 */
proto.saufdings.CreateTournamentRequest.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated TeamInput teams = 4;
 * @return {!Array<!proto.saufdings.TeamInput>}
 */
proto.saufdings.CreateTournamentRequest.prototype.getTeamsList = function() {
  return /** @type{!Array<!proto.saufdings.TeamInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saufdings.TeamInput, 4));
};


/**
 * @param {!Array<!proto.saufdings.TeamInput>} value
 * @return {!proto.saufdings.CreateTournamentRequest} returns this
*/
proto.saufdings.CreateTournamentRequest.prototype.setTeamsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.saufdings.TeamInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saufdings.TeamInput}
 */
proto.saufdings.CreateTournamentRequest.prototype.addTeams = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.saufdings.TeamInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saufdings.CreateTournamentRequest} returns this
 */
proto.saufdings.CreateTournamentRequest.prototype.clearTeamsList = function() {
  return this.setTeamsList([]);
};


/**
 * optional TournamentStyle tournament_style = 5;
 * @return {!proto.saufdings.TournamentStyle}
 */
proto.saufdings.CreateTournamentRequest.prototype.getTournamentStyle = function() {
  return /** @type {!proto.saufdings.TournamentStyle} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.saufdings.TournamentStyle} value
 * @return {!proto.saufdings.CreateTournamentRequest} returns this
 */
proto.saufdings.CreateTournamentRequest.prototype.setTournamentStyle = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional TournamentVisibility visibility = 6;
 * @return {!proto.saufdings.TournamentVisibility}
 */
proto.saufdings.CreateTournamentRequest.prototype.getVisibility = function() {
  return /** @type {!proto.saufdings.TournamentVisibility} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.saufdings.TournamentVisibility} value
 * @return {!proto.saufdings.CreateTournamentRequest} returns this
 */
proto.saufdings.CreateTournamentRequest.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string access_password = 7;
 * @return {string}
 */
proto.saufdings.CreateTournamentRequest.prototype.getAccessPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.CreateTournamentRequest} returns this
 */
proto.saufdings.CreateTournamentRequest.prototype.setAccessPassword = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.CreateTournamentRequest} returns this
 */
proto.saufdings.CreateTournamentRequest.prototype.clearAccessPassword = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.CreateTournamentRequest.prototype.hasAccessPassword = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional users.UserData user = 8;
 * @return {?proto.users.UserData}
 */
proto.saufdings.CreateTournamentRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 8));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.CreateTournamentRequest} returns this
*/
proto.saufdings.CreateTournamentRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.CreateTournamentRequest} returns this
 */
proto.saufdings.CreateTournamentRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.CreateTournamentRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saufdings.TeamInput.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.TeamInput.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.TeamInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.TeamInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.TeamInput.toObject = function(includeInstance, msg) {
  var f, obj = {
teamName: jspb.Message.getFieldWithDefault(msg, 1, ""),
participantsList: jspb.Message.toObjectList(msg.getParticipantsList(),
    proto.saufdings.ParticipantInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.TeamInput}
 */
proto.saufdings.TeamInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.TeamInput;
  return proto.saufdings.TeamInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.TeamInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.TeamInput}
 */
proto.saufdings.TeamInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamName(value);
      break;
    case 2:
      var value = new proto.saufdings.ParticipantInput;
      reader.readMessage(value,proto.saufdings.ParticipantInput.deserializeBinaryFromReader);
      msg.addParticipants(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.TeamInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.TeamInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.TeamInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.TeamInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getParticipantsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.saufdings.ParticipantInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string team_name = 1;
 * @return {string}
 */
proto.saufdings.TeamInput.prototype.getTeamName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.TeamInput} returns this
 */
proto.saufdings.TeamInput.prototype.setTeamName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ParticipantInput participants = 2;
 * @return {!Array<!proto.saufdings.ParticipantInput>}
 */
proto.saufdings.TeamInput.prototype.getParticipantsList = function() {
  return /** @type{!Array<!proto.saufdings.ParticipantInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saufdings.ParticipantInput, 2));
};


/**
 * @param {!Array<!proto.saufdings.ParticipantInput>} value
 * @return {!proto.saufdings.TeamInput} returns this
*/
proto.saufdings.TeamInput.prototype.setParticipantsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.saufdings.ParticipantInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saufdings.ParticipantInput}
 */
proto.saufdings.TeamInput.prototype.addParticipants = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.saufdings.ParticipantInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saufdings.TeamInput} returns this
 */
proto.saufdings.TeamInput.prototype.clearParticipantsList = function() {
  return this.setParticipantsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.ParticipantInput.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.ParticipantInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.ParticipantInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.ParticipantInput.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.ParticipantInput}
 */
proto.saufdings.ParticipantInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.ParticipantInput;
  return proto.saufdings.ParticipantInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.ParticipantInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.ParticipantInput}
 */
proto.saufdings.ParticipantInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.ParticipantInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.ParticipantInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.ParticipantInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.ParticipantInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.saufdings.ParticipantInput.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.ParticipantInput} returns this
 */
proto.saufdings.ParticipantInput.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.saufdings.ParticipantInput.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.ParticipantInput} returns this
 */
proto.saufdings.ParticipantInput.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.GetTournamentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.GetTournamentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.GetTournamentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.GetTournamentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
tournamentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f),
accessPassword: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.GetTournamentRequest}
 */
proto.saufdings.GetTournamentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.GetTournamentRequest;
  return proto.saufdings.GetTournamentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.GetTournamentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.GetTournamentRequest}
 */
proto.saufdings.GetTournamentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTournamentId(value);
      break;
    case 2:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.GetTournamentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.GetTournamentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.GetTournamentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.GetTournamentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTournamentId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 tournament_id = 1;
 * @return {number}
 */
proto.saufdings.GetTournamentRequest.prototype.getTournamentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.GetTournamentRequest} returns this
 */
proto.saufdings.GetTournamentRequest.prototype.setTournamentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional users.UserData user = 2;
 * @return {?proto.users.UserData}
 */
proto.saufdings.GetTournamentRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 2));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.GetTournamentRequest} returns this
*/
proto.saufdings.GetTournamentRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.GetTournamentRequest} returns this
 */
proto.saufdings.GetTournamentRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.GetTournamentRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string access_password = 3;
 * @return {string}
 */
proto.saufdings.GetTournamentRequest.prototype.getAccessPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.GetTournamentRequest} returns this
 */
proto.saufdings.GetTournamentRequest.prototype.setAccessPassword = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.GetTournamentRequest} returns this
 */
proto.saufdings.GetTournamentRequest.prototype.clearAccessPassword = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.GetTournamentRequest.prototype.hasAccessPassword = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.ListTournamentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.ListTournamentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.ListTournamentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.ListTournamentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
eventId: jspb.Message.getFieldWithDefault(msg, 1, 0),
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.ListTournamentsRequest}
 */
proto.saufdings.ListTournamentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.ListTournamentsRequest;
  return proto.saufdings.ListTournamentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.ListTournamentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.ListTournamentsRequest}
 */
proto.saufdings.ListTournamentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEventId(value);
      break;
    case 2:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.ListTournamentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.ListTournamentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.ListTournamentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.ListTournamentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 event_id = 1;
 * @return {number}
 */
proto.saufdings.ListTournamentsRequest.prototype.getEventId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.ListTournamentsRequest} returns this
 */
proto.saufdings.ListTournamentsRequest.prototype.setEventId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional users.UserData user = 2;
 * @return {?proto.users.UserData}
 */
proto.saufdings.ListTournamentsRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 2));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.ListTournamentsRequest} returns this
*/
proto.saufdings.ListTournamentsRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.ListTournamentsRequest} returns this
 */
proto.saufdings.ListTournamentsRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.ListTournamentsRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saufdings.TournamentList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.TournamentList.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.TournamentList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.TournamentList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.TournamentList.toObject = function(includeInstance, msg) {
  var f, obj = {
tournamentsList: jspb.Message.toObjectList(msg.getTournamentsList(),
    proto.saufdings.Tournament.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.TournamentList}
 */
proto.saufdings.TournamentList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.TournamentList;
  return proto.saufdings.TournamentList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.TournamentList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.TournamentList}
 */
proto.saufdings.TournamentList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saufdings.Tournament;
      reader.readMessage(value,proto.saufdings.Tournament.deserializeBinaryFromReader);
      msg.addTournaments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.TournamentList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.TournamentList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.TournamentList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.TournamentList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTournamentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saufdings.Tournament.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Tournament tournaments = 1;
 * @return {!Array<!proto.saufdings.Tournament>}
 */
proto.saufdings.TournamentList.prototype.getTournamentsList = function() {
  return /** @type{!Array<!proto.saufdings.Tournament>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saufdings.Tournament, 1));
};


/**
 * @param {!Array<!proto.saufdings.Tournament>} value
 * @return {!proto.saufdings.TournamentList} returns this
*/
proto.saufdings.TournamentList.prototype.setTournamentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saufdings.Tournament=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saufdings.Tournament}
 */
proto.saufdings.TournamentList.prototype.addTournaments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saufdings.Tournament, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saufdings.TournamentList} returns this
 */
proto.saufdings.TournamentList.prototype.clearTournamentsList = function() {
  return this.setTournamentsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saufdings.Tournament.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.Tournament.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.Tournament.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.Tournament} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Tournament.toObject = function(includeInstance, msg) {
  var f, obj = {
tournamentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
tournamentName: jspb.Message.getFieldWithDefault(msg, 2, ""),
eventId: jspb.Message.getFieldWithDefault(msg, 3, 0),
createdBy: jspb.Message.getFieldWithDefault(msg, 4, 0),
tsCreated: (f = msg.getTsCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
teamsList: jspb.Message.toObjectList(msg.getTeamsList(),
    proto.saufdings.Team.toObject, includeInstance),
matchesList: jspb.Message.toObjectList(msg.getMatchesList(),
    proto.saufdings.Match.toObject, includeInstance),
tournamentStyle: jspb.Message.getFieldWithDefault(msg, 8, 0),
status: jspb.Message.getFieldWithDefault(msg, 9, 0),
visibility: jspb.Message.getFieldWithDefault(msg, 10, 0),
requiresPassword: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
isOwner: jspb.Message.getBooleanFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.Tournament}
 */
proto.saufdings.Tournament.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.Tournament;
  return proto.saufdings.Tournament.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.Tournament} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.Tournament}
 */
proto.saufdings.Tournament.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTournamentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTournamentName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEventId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCreatedBy(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTsCreated(value);
      break;
    case 6:
      var value = new proto.saufdings.Team;
      reader.readMessage(value,proto.saufdings.Team.deserializeBinaryFromReader);
      msg.addTeams(value);
      break;
    case 7:
      var value = new proto.saufdings.Match;
      reader.readMessage(value,proto.saufdings.Match.deserializeBinaryFromReader);
      msg.addMatches(value);
      break;
    case 8:
      var value = /** @type {!proto.saufdings.TournamentStyle} */ (reader.readEnum());
      msg.setTournamentStyle(value);
      break;
    case 9:
      var value = /** @type {!proto.saufdings.TournamentStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {!proto.saufdings.TournamentVisibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequiresPassword(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOwner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.Tournament.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.Tournament.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.Tournament} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Tournament.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTournamentId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTournamentName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEventId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCreatedBy();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTsCreated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTeamsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.saufdings.Team.serializeBinaryToWriter
    );
  }
  f = message.getMatchesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.saufdings.Match.serializeBinaryToWriter
    );
  }
  f = message.getTournamentStyle();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getRequiresPassword();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getIsOwner();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * optional int64 tournament_id = 1;
 * @return {number}
 */
proto.saufdings.Tournament.prototype.getTournamentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Tournament} returns this
 */
proto.saufdings.Tournament.prototype.setTournamentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string tournament_name = 2;
 * @return {string}
 */
proto.saufdings.Tournament.prototype.getTournamentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.Tournament} returns this
 */
proto.saufdings.Tournament.prototype.setTournamentName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 event_id = 3;
 * @return {number}
 */
proto.saufdings.Tournament.prototype.getEventId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Tournament} returns this
 */
proto.saufdings.Tournament.prototype.setEventId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 created_by = 4;
 * @return {number}
 */
proto.saufdings.Tournament.prototype.getCreatedBy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Tournament} returns this
 */
proto.saufdings.Tournament.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp ts_created = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saufdings.Tournament.prototype.getTsCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saufdings.Tournament} returns this
*/
proto.saufdings.Tournament.prototype.setTsCreated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.Tournament} returns this
 */
proto.saufdings.Tournament.prototype.clearTsCreated = function() {
  return this.setTsCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.Tournament.prototype.hasTsCreated = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated Team teams = 6;
 * @return {!Array<!proto.saufdings.Team>}
 */
proto.saufdings.Tournament.prototype.getTeamsList = function() {
  return /** @type{!Array<!proto.saufdings.Team>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saufdings.Team, 6));
};


/**
 * @param {!Array<!proto.saufdings.Team>} value
 * @return {!proto.saufdings.Tournament} returns this
*/
proto.saufdings.Tournament.prototype.setTeamsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.saufdings.Team=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saufdings.Team}
 */
proto.saufdings.Tournament.prototype.addTeams = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.saufdings.Team, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saufdings.Tournament} returns this
 */
proto.saufdings.Tournament.prototype.clearTeamsList = function() {
  return this.setTeamsList([]);
};


/**
 * repeated Match matches = 7;
 * @return {!Array<!proto.saufdings.Match>}
 */
proto.saufdings.Tournament.prototype.getMatchesList = function() {
  return /** @type{!Array<!proto.saufdings.Match>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saufdings.Match, 7));
};


/**
 * @param {!Array<!proto.saufdings.Match>} value
 * @return {!proto.saufdings.Tournament} returns this
*/
proto.saufdings.Tournament.prototype.setMatchesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.saufdings.Match=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saufdings.Match}
 */
proto.saufdings.Tournament.prototype.addMatches = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.saufdings.Match, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saufdings.Tournament} returns this
 */
proto.saufdings.Tournament.prototype.clearMatchesList = function() {
  return this.setMatchesList([]);
};


/**
 * optional TournamentStyle tournament_style = 8;
 * @return {!proto.saufdings.TournamentStyle}
 */
proto.saufdings.Tournament.prototype.getTournamentStyle = function() {
  return /** @type {!proto.saufdings.TournamentStyle} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.saufdings.TournamentStyle} value
 * @return {!proto.saufdings.Tournament} returns this
 */
proto.saufdings.Tournament.prototype.setTournamentStyle = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional TournamentStatus status = 9;
 * @return {!proto.saufdings.TournamentStatus}
 */
proto.saufdings.Tournament.prototype.getStatus = function() {
  return /** @type {!proto.saufdings.TournamentStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.saufdings.TournamentStatus} value
 * @return {!proto.saufdings.Tournament} returns this
 */
proto.saufdings.Tournament.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional TournamentVisibility visibility = 10;
 * @return {!proto.saufdings.TournamentVisibility}
 */
proto.saufdings.Tournament.prototype.getVisibility = function() {
  return /** @type {!proto.saufdings.TournamentVisibility} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.saufdings.TournamentVisibility} value
 * @return {!proto.saufdings.Tournament} returns this
 */
proto.saufdings.Tournament.prototype.setVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional bool requires_password = 11;
 * @return {boolean}
 */
proto.saufdings.Tournament.prototype.getRequiresPassword = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saufdings.Tournament} returns this
 */
proto.saufdings.Tournament.prototype.setRequiresPassword = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool is_owner = 12;
 * @return {boolean}
 */
proto.saufdings.Tournament.prototype.getIsOwner = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saufdings.Tournament} returns this
 */
proto.saufdings.Tournament.prototype.setIsOwner = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saufdings.Team.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.Team.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.Team.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.Team} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Team.toObject = function(includeInstance, msg) {
  var f, obj = {
teamId: jspb.Message.getFieldWithDefault(msg, 1, 0),
teamName: jspb.Message.getFieldWithDefault(msg, 2, ""),
membersList: jspb.Message.toObjectList(msg.getMembersList(),
    proto.saufdings.TeamMember.toObject, includeInstance),
isEliminated: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.Team}
 */
proto.saufdings.Team.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.Team;
  return proto.saufdings.Team.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.Team} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.Team}
 */
proto.saufdings.Team.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamName(value);
      break;
    case 3:
      var value = new proto.saufdings.TeamMember;
      reader.readMessage(value,proto.saufdings.TeamMember.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEliminated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.Team.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.Team.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.Team} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Team.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTeamName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.saufdings.TeamMember.serializeBinaryToWriter
    );
  }
  f = message.getIsEliminated();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional int64 team_id = 1;
 * @return {number}
 */
proto.saufdings.Team.prototype.getTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Team} returns this
 */
proto.saufdings.Team.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string team_name = 2;
 * @return {string}
 */
proto.saufdings.Team.prototype.getTeamName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.Team} returns this
 */
proto.saufdings.Team.prototype.setTeamName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated TeamMember members = 3;
 * @return {!Array<!proto.saufdings.TeamMember>}
 */
proto.saufdings.Team.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.saufdings.TeamMember>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saufdings.TeamMember, 3));
};


/**
 * @param {!Array<!proto.saufdings.TeamMember>} value
 * @return {!proto.saufdings.Team} returns this
*/
proto.saufdings.Team.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.saufdings.TeamMember=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saufdings.TeamMember}
 */
proto.saufdings.Team.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.saufdings.TeamMember, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saufdings.Team} returns this
 */
proto.saufdings.Team.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


/**
 * optional bool is_eliminated = 4;
 * @return {boolean}
 */
proto.saufdings.Team.prototype.getIsEliminated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saufdings.Team} returns this
 */
proto.saufdings.Team.prototype.setIsEliminated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.TeamMember.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.TeamMember.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.TeamMember} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.TeamMember.toObject = function(includeInstance, msg) {
  var f, obj = {
teamMemberId: jspb.Message.getFieldWithDefault(msg, 1, 0),
userId: jspb.Message.getFieldWithDefault(msg, 2, 0),
displayName: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.TeamMember}
 */
proto.saufdings.TeamMember.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.TeamMember;
  return proto.saufdings.TeamMember.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.TeamMember} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.TeamMember}
 */
proto.saufdings.TeamMember.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTeamMemberId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.TeamMember.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.TeamMember.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.TeamMember} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.TeamMember.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamMemberId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 team_member_id = 1;
 * @return {number}
 */
proto.saufdings.TeamMember.prototype.getTeamMemberId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.TeamMember} returns this
 */
proto.saufdings.TeamMember.prototype.setTeamMemberId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.saufdings.TeamMember.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.TeamMember} returns this
 */
proto.saufdings.TeamMember.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.saufdings.TeamMember.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.TeamMember} returns this
 */
proto.saufdings.TeamMember.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.Match.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.Match.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.Match} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Match.toObject = function(includeInstance, msg) {
  var f, obj = {
matchId: jspb.Message.getFieldWithDefault(msg, 1, 0),
tournamentId: jspb.Message.getFieldWithDefault(msg, 2, 0),
teamAId: jspb.Message.getFieldWithDefault(msg, 3, 0),
teamBId: jspb.Message.getFieldWithDefault(msg, 4, 0),
winnerTeamId: jspb.Message.getFieldWithDefault(msg, 5, 0),
roundNumber: jspb.Message.getFieldWithDefault(msg, 6, 0),
tsScheduled: (f = msg.getTsScheduled()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
tsPlayed: (f = msg.getTsPlayed()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
isCancelled: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
bracketType: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.Match}
 */
proto.saufdings.Match.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.Match;
  return proto.saufdings.Match.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.Match} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.Match}
 */
proto.saufdings.Match.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMatchId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTournamentId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTeamAId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTeamBId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWinnerTeamId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoundNumber(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTsScheduled(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTsPlayed(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCancelled(value);
      break;
    case 10:
      var value = /** @type {!proto.saufdings.BracketType} */ (reader.readEnum());
      msg.setBracketType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.Match.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.Match.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.Match} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.Match.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatchId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTournamentId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTeamAId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTeamBId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getWinnerTeamId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getRoundNumber();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getTsScheduled();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTsPlayed();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsCancelled();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getBracketType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
};


/**
 * optional int64 match_id = 1;
 * @return {number}
 */
proto.saufdings.Match.prototype.getMatchId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Match} returns this
 */
proto.saufdings.Match.prototype.setMatchId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 tournament_id = 2;
 * @return {number}
 */
proto.saufdings.Match.prototype.getTournamentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Match} returns this
 */
proto.saufdings.Match.prototype.setTournamentId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 team_a_id = 3;
 * @return {number}
 */
proto.saufdings.Match.prototype.getTeamAId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Match} returns this
 */
proto.saufdings.Match.prototype.setTeamAId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 team_b_id = 4;
 * @return {number}
 */
proto.saufdings.Match.prototype.getTeamBId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Match} returns this
 */
proto.saufdings.Match.prototype.setTeamBId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 winner_team_id = 5;
 * @return {number}
 */
proto.saufdings.Match.prototype.getWinnerTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Match} returns this
 */
proto.saufdings.Match.prototype.setWinnerTeamId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 round_number = 6;
 * @return {number}
 */
proto.saufdings.Match.prototype.getRoundNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.Match} returns this
 */
proto.saufdings.Match.prototype.setRoundNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp ts_scheduled = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saufdings.Match.prototype.getTsScheduled = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saufdings.Match} returns this
*/
proto.saufdings.Match.prototype.setTsScheduled = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.Match} returns this
 */
proto.saufdings.Match.prototype.clearTsScheduled = function() {
  return this.setTsScheduled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.Match.prototype.hasTsScheduled = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp ts_played = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saufdings.Match.prototype.getTsPlayed = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saufdings.Match} returns this
*/
proto.saufdings.Match.prototype.setTsPlayed = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.Match} returns this
 */
proto.saufdings.Match.prototype.clearTsPlayed = function() {
  return this.setTsPlayed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.Match.prototype.hasTsPlayed = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool is_cancelled = 9;
 * @return {boolean}
 */
proto.saufdings.Match.prototype.getIsCancelled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saufdings.Match} returns this
 */
proto.saufdings.Match.prototype.setIsCancelled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional BracketType bracket_type = 10;
 * @return {!proto.saufdings.BracketType}
 */
proto.saufdings.Match.prototype.getBracketType = function() {
  return /** @type {!proto.saufdings.BracketType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.saufdings.BracketType} value
 * @return {!proto.saufdings.Match} returns this
 */
proto.saufdings.Match.prototype.setBracketType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.UpdateMatchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.UpdateMatchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.UpdateMatchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.UpdateMatchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
matchId: jspb.Message.getFieldWithDefault(msg, 1, 0),
teamAId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
teamBId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
winnerTeamId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
roundNumber: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
tsScheduled: (f = msg.getTsScheduled()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
tsPlayed: (f = msg.getTsPlayed()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.UpdateMatchRequest}
 */
proto.saufdings.UpdateMatchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.UpdateMatchRequest;
  return proto.saufdings.UpdateMatchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.UpdateMatchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.UpdateMatchRequest}
 */
proto.saufdings.UpdateMatchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMatchId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTeamAId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTeamBId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWinnerTeamId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoundNumber(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTsScheduled(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTsPlayed(value);
      break;
    case 8:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.UpdateMatchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.UpdateMatchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.UpdateMatchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.UpdateMatchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatchId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTsScheduled();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTsPlayed();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 match_id = 1;
 * @return {number}
 */
proto.saufdings.UpdateMatchRequest.prototype.getMatchId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
 */
proto.saufdings.UpdateMatchRequest.prototype.setMatchId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 team_a_id = 2;
 * @return {number}
 */
proto.saufdings.UpdateMatchRequest.prototype.getTeamAId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
 */
proto.saufdings.UpdateMatchRequest.prototype.setTeamAId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
 */
proto.saufdings.UpdateMatchRequest.prototype.clearTeamAId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateMatchRequest.prototype.hasTeamAId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 team_b_id = 3;
 * @return {number}
 */
proto.saufdings.UpdateMatchRequest.prototype.getTeamBId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
 */
proto.saufdings.UpdateMatchRequest.prototype.setTeamBId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
 */
proto.saufdings.UpdateMatchRequest.prototype.clearTeamBId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateMatchRequest.prototype.hasTeamBId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 winner_team_id = 4;
 * @return {number}
 */
proto.saufdings.UpdateMatchRequest.prototype.getWinnerTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
 */
proto.saufdings.UpdateMatchRequest.prototype.setWinnerTeamId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
 */
proto.saufdings.UpdateMatchRequest.prototype.clearWinnerTeamId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateMatchRequest.prototype.hasWinnerTeamId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 round_number = 5;
 * @return {number}
 */
proto.saufdings.UpdateMatchRequest.prototype.getRoundNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
 */
proto.saufdings.UpdateMatchRequest.prototype.setRoundNumber = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
 */
proto.saufdings.UpdateMatchRequest.prototype.clearRoundNumber = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateMatchRequest.prototype.hasRoundNumber = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp ts_scheduled = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saufdings.UpdateMatchRequest.prototype.getTsScheduled = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
*/
proto.saufdings.UpdateMatchRequest.prototype.setTsScheduled = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
 */
proto.saufdings.UpdateMatchRequest.prototype.clearTsScheduled = function() {
  return this.setTsScheduled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateMatchRequest.prototype.hasTsScheduled = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp ts_played = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saufdings.UpdateMatchRequest.prototype.getTsPlayed = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
*/
proto.saufdings.UpdateMatchRequest.prototype.setTsPlayed = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
 */
proto.saufdings.UpdateMatchRequest.prototype.clearTsPlayed = function() {
  return this.setTsPlayed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateMatchRequest.prototype.hasTsPlayed = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional users.UserData user = 8;
 * @return {?proto.users.UserData}
 */
proto.saufdings.UpdateMatchRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 8));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
*/
proto.saufdings.UpdateMatchRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.UpdateMatchRequest} returns this
 */
proto.saufdings.UpdateMatchRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateMatchRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.UpdateTournamentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.UpdateTournamentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.UpdateTournamentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.UpdateTournamentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
tournamentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
status: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
tournamentStyle: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f),
visibility: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
accessPassword: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.UpdateTournamentRequest}
 */
proto.saufdings.UpdateTournamentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.UpdateTournamentRequest;
  return proto.saufdings.UpdateTournamentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.UpdateTournamentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.UpdateTournamentRequest}
 */
proto.saufdings.UpdateTournamentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTournamentId(value);
      break;
    case 2:
      var value = /** @type {!proto.saufdings.TournamentStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {!proto.saufdings.TournamentStyle} */ (reader.readEnum());
      msg.setTournamentStyle(value);
      break;
    case 4:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 5:
      var value = /** @type {!proto.saufdings.TournamentVisibility} */ (reader.readEnum());
      msg.setVisibility(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.UpdateTournamentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.UpdateTournamentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.UpdateTournamentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.UpdateTournamentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTournamentId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {!proto.saufdings.TournamentStatus} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {!proto.saufdings.TournamentStyle} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.saufdings.TournamentVisibility} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int64 tournament_id = 1;
 * @return {number}
 */
proto.saufdings.UpdateTournamentRequest.prototype.getTournamentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.UpdateTournamentRequest} returns this
 */
proto.saufdings.UpdateTournamentRequest.prototype.setTournamentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional TournamentStatus status = 2;
 * @return {!proto.saufdings.TournamentStatus}
 */
proto.saufdings.UpdateTournamentRequest.prototype.getStatus = function() {
  return /** @type {!proto.saufdings.TournamentStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.saufdings.TournamentStatus} value
 * @return {!proto.saufdings.UpdateTournamentRequest} returns this
 */
proto.saufdings.UpdateTournamentRequest.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.UpdateTournamentRequest} returns this
 */
proto.saufdings.UpdateTournamentRequest.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateTournamentRequest.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TournamentStyle tournament_style = 3;
 * @return {!proto.saufdings.TournamentStyle}
 */
proto.saufdings.UpdateTournamentRequest.prototype.getTournamentStyle = function() {
  return /** @type {!proto.saufdings.TournamentStyle} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.saufdings.TournamentStyle} value
 * @return {!proto.saufdings.UpdateTournamentRequest} returns this
 */
proto.saufdings.UpdateTournamentRequest.prototype.setTournamentStyle = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.UpdateTournamentRequest} returns this
 */
proto.saufdings.UpdateTournamentRequest.prototype.clearTournamentStyle = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateTournamentRequest.prototype.hasTournamentStyle = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional users.UserData user = 4;
 * @return {?proto.users.UserData}
 */
proto.saufdings.UpdateTournamentRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 4));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.UpdateTournamentRequest} returns this
*/
proto.saufdings.UpdateTournamentRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.UpdateTournamentRequest} returns this
 */
proto.saufdings.UpdateTournamentRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateTournamentRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional TournamentVisibility visibility = 5;
 * @return {!proto.saufdings.TournamentVisibility}
 */
proto.saufdings.UpdateTournamentRequest.prototype.getVisibility = function() {
  return /** @type {!proto.saufdings.TournamentVisibility} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.saufdings.TournamentVisibility} value
 * @return {!proto.saufdings.UpdateTournamentRequest} returns this
 */
proto.saufdings.UpdateTournamentRequest.prototype.setVisibility = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.UpdateTournamentRequest} returns this
 */
proto.saufdings.UpdateTournamentRequest.prototype.clearVisibility = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateTournamentRequest.prototype.hasVisibility = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string access_password = 6;
 * @return {string}
 */
proto.saufdings.UpdateTournamentRequest.prototype.getAccessPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.saufdings.UpdateTournamentRequest} returns this
 */
proto.saufdings.UpdateTournamentRequest.prototype.setAccessPassword = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.saufdings.UpdateTournamentRequest} returns this
 */
proto.saufdings.UpdateTournamentRequest.prototype.clearAccessPassword = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.UpdateTournamentRequest.prototype.hasAccessPassword = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.EliminateTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.EliminateTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.EliminateTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.EliminateTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
tournamentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
teamId: jspb.Message.getFieldWithDefault(msg, 2, 0),
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.EliminateTeamRequest}
 */
proto.saufdings.EliminateTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.EliminateTeamRequest;
  return proto.saufdings.EliminateTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.EliminateTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.EliminateTeamRequest}
 */
proto.saufdings.EliminateTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTournamentId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTeamId(value);
      break;
    case 3:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.EliminateTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.EliminateTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.EliminateTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.EliminateTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTournamentId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTeamId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 tournament_id = 1;
 * @return {number}
 */
proto.saufdings.EliminateTeamRequest.prototype.getTournamentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.EliminateTeamRequest} returns this
 */
proto.saufdings.EliminateTeamRequest.prototype.setTournamentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 team_id = 2;
 * @return {number}
 */
proto.saufdings.EliminateTeamRequest.prototype.getTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.EliminateTeamRequest} returns this
 */
proto.saufdings.EliminateTeamRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional users.UserData user = 3;
 * @return {?proto.users.UserData}
 */
proto.saufdings.EliminateTeamRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 3));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.EliminateTeamRequest} returns this
*/
proto.saufdings.EliminateTeamRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.EliminateTeamRequest} returns this
 */
proto.saufdings.EliminateTeamRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.EliminateTeamRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.ReinstateTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.ReinstateTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.ReinstateTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.ReinstateTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
tournamentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
teamId: jspb.Message.getFieldWithDefault(msg, 2, 0),
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.ReinstateTeamRequest}
 */
proto.saufdings.ReinstateTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.ReinstateTeamRequest;
  return proto.saufdings.ReinstateTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.ReinstateTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.ReinstateTeamRequest}
 */
proto.saufdings.ReinstateTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTournamentId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTeamId(value);
      break;
    case 3:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.ReinstateTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.ReinstateTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.ReinstateTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.ReinstateTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTournamentId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTeamId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 tournament_id = 1;
 * @return {number}
 */
proto.saufdings.ReinstateTeamRequest.prototype.getTournamentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.ReinstateTeamRequest} returns this
 */
proto.saufdings.ReinstateTeamRequest.prototype.setTournamentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 team_id = 2;
 * @return {number}
 */
proto.saufdings.ReinstateTeamRequest.prototype.getTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.ReinstateTeamRequest} returns this
 */
proto.saufdings.ReinstateTeamRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional users.UserData user = 3;
 * @return {?proto.users.UserData}
 */
proto.saufdings.ReinstateTeamRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 3));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.ReinstateTeamRequest} returns this
*/
proto.saufdings.ReinstateTeamRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.ReinstateTeamRequest} returns this
 */
proto.saufdings.ReinstateTeamRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.ReinstateTeamRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.AdvanceTournamentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.AdvanceTournamentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.AdvanceTournamentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.AdvanceTournamentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
tournamentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.AdvanceTournamentRequest}
 */
proto.saufdings.AdvanceTournamentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.AdvanceTournamentRequest;
  return proto.saufdings.AdvanceTournamentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.AdvanceTournamentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.AdvanceTournamentRequest}
 */
proto.saufdings.AdvanceTournamentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTournamentId(value);
      break;
    case 2:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.AdvanceTournamentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.AdvanceTournamentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.AdvanceTournamentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.AdvanceTournamentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTournamentId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 tournament_id = 1;
 * @return {number}
 */
proto.saufdings.AdvanceTournamentRequest.prototype.getTournamentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.AdvanceTournamentRequest} returns this
 */
proto.saufdings.AdvanceTournamentRequest.prototype.setTournamentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional users.UserData user = 2;
 * @return {?proto.users.UserData}
 */
proto.saufdings.AdvanceTournamentRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 2));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.AdvanceTournamentRequest} returns this
*/
proto.saufdings.AdvanceTournamentRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.AdvanceTournamentRequest} returns this
 */
proto.saufdings.AdvanceTournamentRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.AdvanceTournamentRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saufdings.DeleteTournamentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saufdings.DeleteTournamentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saufdings.DeleteTournamentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.DeleteTournamentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
tournamentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saufdings.DeleteTournamentRequest}
 */
proto.saufdings.DeleteTournamentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saufdings.DeleteTournamentRequest;
  return proto.saufdings.DeleteTournamentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saufdings.DeleteTournamentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saufdings.DeleteTournamentRequest}
 */
proto.saufdings.DeleteTournamentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTournamentId(value);
      break;
    case 2:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saufdings.DeleteTournamentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saufdings.DeleteTournamentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saufdings.DeleteTournamentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saufdings.DeleteTournamentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTournamentId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 tournament_id = 1;
 * @return {number}
 */
proto.saufdings.DeleteTournamentRequest.prototype.getTournamentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saufdings.DeleteTournamentRequest} returns this
 */
proto.saufdings.DeleteTournamentRequest.prototype.setTournamentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional users.UserData user = 2;
 * @return {?proto.users.UserData}
 */
proto.saufdings.DeleteTournamentRequest.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 2));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.saufdings.DeleteTournamentRequest} returns this
*/
proto.saufdings.DeleteTournamentRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saufdings.DeleteTournamentRequest} returns this
 */
proto.saufdings.DeleteTournamentRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saufdings.DeleteTournamentRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.saufdings.BracketType = {
  BRACKET_TYPE_UNSPECIFIED: 0,
  BRACKET_TYPE_WINNERS: 1,
  BRACKET_TYPE_LOSERS: 2,
  BRACKET_TYPE_FINALS: 3
};

/**
 * @enum {number}
 */
proto.saufdings.TournamentStyle = {
  TOURNAMENT_STYLE_UNSPECIFIED: 0,
  TOURNAMENT_STYLE_ROUND_ROBIN: 1,
  TOURNAMENT_STYLE_SINGLE_ELIMINATION: 2,
  TOURNAMENT_STYLE_DOUBLE_ELIMINATION: 3,
  TOURNAMENT_STYLE_HYBRID: 4
};

/**
 * @enum {number}
 */
proto.saufdings.TournamentStatus = {
  TOURNAMENT_STATUS_UNSPECIFIED: 0,
  TOURNAMENT_STATUS_ACTIVE: 1,
  TOURNAMENT_STATUS_COMPLETED: 2,
  TOURNAMENT_STATUS_CANCELLED: 3
};

/**
 * @enum {number}
 */
proto.saufdings.TournamentVisibility = {
  TOURNAMENT_VISIBILITY_PUBLIC: 0,
  TOURNAMENT_VISIBILITY_FRIENDS: 1,
  TOURNAMENT_VISIBILITY_PASSWORD: 2,
  TOURNAMENT_VISIBILITY_PRIVATE: 3
};

goog.object.extend(exports, proto.saufdings);
